import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  withStyles,
  Card,
  Typography,
  CardContent,
  Button,
} from '@material-ui/core';
import Auth0LockService from '../../../services/AuthService/Auth0LockService';
import { getTenantFromUrl } from '../../../utils/urlHelper';
import { logoutSuccess } from '../../../redux/auth/actions';
import LoadingPage from '../LoadingPage';
import styles from './styles';

const isLoggedOut = () => {
  if (!getTenantFromUrl()) {
    return true;
  }
  return false;
};

export class LogoutPageComponent extends React.Component {
  componentDidMount() {
    Auth0LockService.logout();
    const tenant = getTenantFromUrl();
    this.props.logout();
    if (tenant) {
      window.location.hostname = window.location.hostname.replace(`${tenant}.`, '');
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        {
          !isLoggedOut()
          && <LoadingPage />
        }
        {
          isLoggedOut()
          && (
            <div className={classes.container}>
              <Card className={classes.card}>
                <CardContent>
                  <Typography
                    variant="h3"
                    align="center"
                  >
                    Logged out
                  </Typography>
                  <Typography variant="subtitle1" align="center" gutterBottom>
                    You have been logged out.
                  </Typography>
                  <div className={classes.buttonContainer}>
                    <Button
                      color="secondary"
                      size="small"
                      href="/"
                      variant="contained"
                    >
                      Return Home
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </div>
          )
        }
      </div>
    );
  }
}

LogoutPageComponent.propTypes = {
  logout: PropTypes.func.isRequired,
  classes: PropTypes.object,
};

LogoutPageComponent.defaultProps = { classes: {} };

export const mapDispatchToProps = (dispatch) => ({ logout: () => dispatch(logoutSuccess()) });

export default withStyles(styles)(withRouter(connect(
  null,
  mapDispatchToProps,
)(LogoutPageComponent)));
